module.exports = __webpack_public_path__ + "img/circle-m.e6b82c86.svg";